"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ButtonGroup = require("./ButtonGroup");

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _InputSearch = require("./InputSearch");

var _InputSearch2 = _interopRequireDefault(_InputSearch);

var _InputAutocomplete = require("./InputAutocomplete");

var _InputAutocomplete2 = _interopRequireDefault(_InputAutocomplete);

var _constants = require("../constants");

var _ActionBar = require("../ActionBar");

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _context = require("./context");

var _testing = require("../context/testing");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Toolbar = function Toolbar(_ref) {
  var children = _ref.children;

  var _useTestingContext = (0, _testing.useTestingContext)(),
      testId = _useTestingContext.testId;

  var toolbarTestId = testId + "__toolbar";
  var positionFixer = _react2.default.Children.count(children) > 1 ? null : _react2.default.createElement("div", {
    className: _constants.ORDER_CLASSNAMES.TOOLBAR_CHILD.POSITION_FIXER
  });
  return _react2.default.createElement(_ActionBar2.default, {
    id: _constants.NAMESPACES.TOOLBAR.CONTAINER,
    testId: toolbarTestId,
    order: _constants.ORDER_CLASSNAMES.TOOLBAR,
    className: "flex flex-row flex-wrap w-100 justify-between"
  }, _react2.default.createElement(_context.ToolbarProvider, {
    testId: toolbarTestId
  }, children, positionFixer));
};

Toolbar.InputSearch = _InputSearch2.default;
Toolbar.ButtonGroup = _ButtonGroup2.default;
Toolbar.InputAutocomplete = _InputAutocomplete2.default;
exports.default = Toolbar;